import { createContext } from 'react';

export const PageChangeContext = createContext<{ pageUrlChanged?: symbol }>({
  pageUrlChanged: undefined,
});
